import * as React from 'react';

import ClosedLeadTasksSvg from '../assets/closed-lead-tasks.svg';

import styles from './help-graphic-closed-lead-tasks.module.css';

export class HelpGraphicClosedLeadTasks extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.tasks}>
                <ClosedLeadTasksSvg />
            </div>
        );
    }
}
